import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ContentList } from "./ContentList";

const list1Content = [
  `z zaburzeniami mowy będącymi wynikiem uszkodzenia ośrodkowego i
  obwodowego układu nerwowego (afazją, dyzartrią, apraksją mowy) np. osób
  po udarach mózgu, urazach czaszkowo-mózgowych, chorobach infekcyjnych
  układu nerwowego, w trakcie i po leczeniu onkologicznym,`,
  `z zaburzeniami mowy w chorobach neurozwyrodnieniowych (choroba
    Parkinsona, choroba Alzheimera, stwardnienie zanikowe boczne – SLA i
    inne),`,
  `z zaburzeniami miofunkcjonalnymi mięśni obszaru ustno-twarzowego (np. z
      zaburzonym torem oddechowym – nawykowe oddychanie przez usta,
      chrapaniem, nieprawidłową pozycją spoczynkową języka, nieprawidłowym
      połykaniem),`,
  `z wadami wymowy oraz wymową niewyraźną,`,
  `z zaburzeniami głosu (kształtowanie prawidłowych nawyków oddechowych,
    fonacyjnych, artykulacyjnych)`,
];

const list2Content = [
  `terapia jąkania u osób dorosłych (m.in. wg modelu CARE),`,
  `wsparcie leczenia ortodontycznego (terapia przed oraz w trakcie leczenia
  ortodontycznego),`,
  `wprowadzanie komunikacji wspomagającej i alternatywnej (AAC) m.in. u
dorosłych z afazją, dyzartrią, apraksją mowy, autyzmem,`,
  `profilaktyka, diagnoza oraz terapia zaburzeń mowy osób starszych
  (wspomaganie prawidłowego oddychania, artykulacji, sprawności komunikacyjnych
  i językowych oraz innych wyższych funkcji poznawczych związanych z mową:
  pamięci, uwagi, funkcji wzrokowych),`,
];

export function AdultService() {
  return (
    <Stack>
      <Typography variant="h3" fontWeight={"medium"}>
        TERAPIA DOROSŁYCH:
      </Typography>
      <ContentList listContent={list1Content} />
      <Typography variant="h4" fontWeight={"medium"}>
        oraz:
      </Typography>
      <ContentList listContent={list2Content} />
    </Stack>
  );
}
